<template>
  <v-menu v-model="show" :close-on-content-click="false" offset-y transition="slide-y-transition">
    <template v-slot:activator="{ on }">
      <v-btn x-small block :color="color" v-on="on">{{ color }}</v-btn>
    </template>
    <v-card class="mx-auto">
      <v-row :no-gutters="true" v-for="(c, i) in colors" :key="i">
        <v-col>
          <v-btn x-small tile block :color="c" @click="select(c)">{{ c }}</v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: '#FFFFFF',
    },
    showWrapper: Boolean,
  },
  data: () => ({
    show: false,
    colors: ['#26A69A', '#00BCD4', '#039BE5', '#7986CB', '#7CB342', '#FBC02D', '#FF6F00', '#E53935', '#F06292', '#9E9E9E'],
  }),
  computed: {
    color: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    showWrapper: {
      immediate: true,
      handler: 'showWrapperHandler',
    },
  },
  methods: {
    showWrapperHandler(show) {
      if (show) {
        this.color = this.value;
      }
    },
    select(c) {
      this.color = c;
      this.show = false;
    },
  },
};
</script>

<style>
.btn-color {
  width: 150px;
}
</style>
